import Lottie from 'lottie-react';
import * as mainLoaderAnimation from './lottie/main-loader.json';
import * as btnLoaderAnimation from './lottie/btn-loader.json';

type Props = {
  size?: number;
  isButton?: boolean;
};

export const Loader = ({ size = 20, isButton = false }: Props) => {
  return (
    <Lottie
      animationData={isButton ? btnLoaderAnimation : mainLoaderAnimation}
      style={{ width: size + 'px' }}
    />
  );
};
